(function() {
  var container = document.querySelector('[data-cart-drawer-container]');
  if (!container) return;

  if (container.dataset.cartJsInitialized === 'true') return;
  container.dataset.cartJsInitialized = 'true';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var debounceTimer = null;
  var DEBOUNCE_MS = 150; /* Was 250 — reduced for snappier qty clicks */

  var SERVICE_VARIANT_ID = container.dataset.engravingVariantId ? Number(container.dataset.engravingVariantId) : null;
  var MAX_CHARS = container.dataset.maxChars ? Number(container.dataset.maxChars) : 8;
  var FIRST_ITEM_TITLE = container.dataset.firstItemTitle || '';
  var FIRST_ITEM_KEY = container.dataset.firstItemKey || '';

  /* Debounce/lock flag for SAVE button */
  var isSaving = false;

  /* Preserve panel state across cart refreshes */
  var panelWasOpen = false;
  var pendingInputText = '';
  var nudgeWasDismissed = false;

  /* Drawer Modal Elements */
  var overlay = document.getElementById('classyCartOverlay');
  var panel   = document.getElementById('classyCartPanel');
  var isOpen  = false;
  var isRefreshing = false; /* Guard against re-entrant cart refresh calls */
  var lastFocused = null;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  /* Inject close button if needed */
  if (panel && !panel.querySelector('.classy-cart-close-btn')) {
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'classy-cart-close-btn';
    closeBtn.setAttribute('aria-label', 'Close cart');
    closeBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    panel.appendChild(closeBtn);
  }

  function trapFocus(e) {
    if (!isOpen || !panel) return;
    var focusable = Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE));
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function openCart() {
    if (isOpen || !overlay || !panel) return;
    isOpen = true;
    lastFocused = document.activeElement;
    overlay.classList.add('is-open');
    panel.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', trapFocus);
    requestAnimationFrame(function() {
      var first = panel.querySelector(FOCUSABLE);
      if (first) first.focus();
    });
  }

  function closeCart() {
    if (!isOpen || !overlay || !panel) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    panel.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', trapFocus);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function refreshAndOpen() {
    document.dispatchEvent(new Event('closeFlyouts'));
    document.querySelectorAll('.atc-banner--container, [data-atc-banner], .atc-banner--visible, overlay-drawer').forEach(function(el) {
      el.classList.remove('atc-banner--visible');
      if (el.tagName && el.tagName.toLowerCase() === 'overlay-drawer') {
        el.removeAttribute('open');
      } else {
        el.style.display = 'none';
      }
    });
    return refreshCart().then(function() {
      openCart();
    });
  }

  function setLoading(on) {
    requestAnimationFrame(function() {
      if (on) container.classList.add('is-loading');
      else container.classList.remove('is-loading');
    });
  }

  function showErrorToast(msg) {
    var toast = container.querySelector('#cart-error-toast');
    if (!toast) return;
    toast.textContent = msg || 'Something went wrong. Please try again.';
    toast.classList.add('is-visible');
    setTimeout(function() {
      toast.classList.remove('is-visible');
    }, 3500);
  }

  function updateContainerFromHtml(text) {
    if (!text) return;
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var fresh = doc.querySelector('.cart-drawer-content');
    if (fresh) {
      var panelEl = container.querySelector('#cp-unfolded-panel');
      var inputField = container.querySelector('#cp-text-input-field');
      var nudge = container.querySelector('#cp-nudge-tooltip');

      if (panelEl) panelWasOpen = (panelEl.style.display !== 'none' && panelEl.style.display !== '');
      if (inputField) pendingInputText = inputField.value || '';
      if (nudge && nudge.style.display === 'none') nudgeWasDismissed = true;

      container.innerHTML = fresh.innerHTML;

      if (fresh.dataset.engravingVariantId) SERVICE_VARIANT_ID = Number(fresh.dataset.engravingVariantId);
      if (fresh.dataset.maxChars) MAX_CHARS = Number(fresh.dataset.maxChars);
      if (fresh.dataset.firstItemTitle) FIRST_ITEM_TITLE = fresh.dataset.firstItemTitle;
      if (fresh.dataset.firstItemKey) FIRST_ITEM_KEY = fresh.dataset.firstItemKey;

      if (panelWasOpen) {
        var newPanel = container.querySelector('#cp-unfolded-panel');
        var newTrigger = container.querySelector('#cp-fold-trigger');
        if (newPanel) newPanel.style.display = 'block';
        if (newTrigger) newTrigger.classList.add('is-open');
      }
      if (pendingInputText) {
        var newInput = container.querySelector('#cp-text-input-field');
        if (newInput) {
          newInput.value = pendingInputText;
          var counter = container.querySelector('#cp-char-count');
          if (counter) counter.textContent = pendingInputText.length;
        }
      }
      if (nudgeWasDismissed) {
        var newNudge = container.querySelector('#cp-nudge-tooltip');
        if (newNudge) newNudge.style.display = 'none';
      }
    }
  }

  /* 1-Shot Section Refresh — single fetch, no double request */
  function refreshCart() {
    if (isRefreshing) return Promise.resolve(); /* Guard: ignore if already refreshing */
    isRefreshing = true;
    setLoading(true);
    var cacheBuster = '&_t=' + Date.now();
    return fetch(root + 'cart?section_id=cart-drawer-section' + cacheBuster, { cache: 'no-store' })
      .then(function(r) { return r.text(); })
      .then(function(text) {
        updateContainerFromHtml(text);
        /* Extract item_count from the freshly rendered HTML data-attributes
           instead of making a second fetch to cart.js */
        var countMatch = text.match(/data-cart-item-count="(\d+)"/);
        if (countMatch) {
          updateHeaderCount(Number(countMatch[1]));
        } else {
          /* Fallback: parse item count from the rendered cart title e.g. "YOUR CART (3)" */
          var titleMatch = text.match(/cart-title[^>]*>.*?\((\d+)\)/);
          if (titleMatch) {
            updateHeaderCount(Number(titleMatch[1]));
          }
        }
      })
      .catch(function(e) {
        console.error('Cart refresh failed', e);
        showErrorToast('Could not refresh cart. Please reload the page.');
      })
      .finally(function() {
        setLoading(false);
        isRefreshing = false;
      });
  }

  function updateHeaderCount(count) {
    var badge = document.querySelector('[data-header-cart-count]');
    if (!badge) return;
    if (count > 0) {
      badge.setAttribute('data-header-cart-count', count);
      badge.classList.add('visible');
    } else {
      badge.setAttribute('data-header-cart-count', '');
      badge.classList.remove('visible');
    }
  }

  /* Efficient 1-shot cart fetch with embedded section rendering */
  function cartFetch(endpoint, body) {
    setLoading(true);
    var payload = Object.assign({}, body || {}, {
      sections: ['cart-drawer-section']
    });

    return fetch(root + 'cart/' + endpoint + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Cart ' + endpoint + ' failed (' + r.status + ')');
      return r.json();
    })
    .then(function(data) {
      if (data && typeof data.item_count !== 'undefined') {
        updateHeaderCount(data.item_count);
      }
      if (data && data.sections && data.sections['cart-drawer-section']) {
        updateContainerFromHtml(data.sections['cart-drawer-section']);
      } else {
        return refreshCart().then(function() { return data; });
      }
      return data;
    })
    .catch(function(e) {
      console.error('Cart update error', e);
      showErrorToast('Failed to update cart. Please try again.');
    })
    .finally(function() {
      setLoading(false);
    });
  }

  function resolveServiceVariantId() {
    if (SERVICE_VARIANT_ID) return Promise.resolve(SERVICE_VARIANT_ID);
    return fetch(root + 'products/monogrammed-leather-bags-fees.js')
      .then(function(r) {
        if (!r.ok) return null;
        return r.json();
      })
      .then(function(p) {
        if (p && p.variants && p.variants.length) {
          SERVICE_VARIANT_ID = p.variants[0].id;
          return SERVICE_VARIANT_ID;
        }
        return null;
      })
      .catch(function() { return null; });
  }

  /* Bundle cleanup helper */
  function cleanupBundledItems(cartData, removedItem, updates) {
    var bundleToken = removedItem.properties ? removedItem.properties['_Artisan Bundle'] : null;
    var removedTitle = removedItem.product_title || '';
    var isService = (removedItem.properties && removedItem.properties['_Artisan Role'] === 'service') ||
                    (SERVICE_VARIANT_ID && removedItem.id === Number(SERVICE_VARIANT_ID)) ||
                    (removedItem.product_title && removedItem.product_title.indexOf('Monogram') !== -1);

    if (isService) {
      var targetTitle = removedItem.properties ? removedItem.properties['Target Product'] : null;
      var mainItem = null;
      if (bundleToken) {
        mainItem = cartData.items.find(function(it) {
          return it.properties && it.properties['_Artisan Bundle'] === bundleToken && it.key !== removedItem.key;
        });
      }
      if (!mainItem && targetTitle) {
        var candidates = cartData.items.filter(function(it) {
          return it.product_title === targetTitle && it.key !== removedItem.key;
        });
        if (candidates.length === 1) {
          mainItem = candidates[0];
        } else if (candidates.length > 1) {
          var feeText = removedItem.properties ? (removedItem.properties['Engraving Text'] || removedItem.properties['Personalisation']) : null;
          if (feeText) {
            mainItem = candidates.find(function(it) {
              return it.properties && (it.properties['Engraving Text'] === feeText || it.properties['Personalisation'] === feeText);
            });
          }
        }
      }

      if (mainItem && mainItem.properties) {
        var cleanProps = Object.assign({}, mainItem.properties);
        cleanProps['Engraving Text'] = '';
        cleanProps['Personalisation'] = '';
        cleanProps['_Engraving'] = '';
        cleanProps['_Artisan Role'] = '';
        cleanProps['_Artisan Bundle'] = '';

        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates, sections: ['cart-drawer-section'] })
        }).then(function() {
          return cartFetch('change', {
            id: mainItem.key,
            quantity: mainItem.quantity,
            properties: cleanProps
          });
        });
      }
      return cartFetch('update', { updates: updates });
    } else {
      cartData.items.forEach(function(it) {
        if (it.key === removedItem.key) return;
        var itToken = it.properties ? it.properties['_Artisan Bundle'] : null;
        var itTarget = it.properties ? it.properties['Target Product'] : null;
        var isFee = (SERVICE_VARIANT_ID && it.id === Number(SERVICE_VARIANT_ID)) ||
                    (it.properties && it.properties['_Artisan Role'] === 'service') ||
                    (it.product_title && it.product_title.indexOf('Monogram') !== -1);

        if (isFee) {
          if (bundleToken && itToken === bundleToken) {
            updates[it.key] = 0;
          } else if (itTarget && itTarget === removedTitle) {
            updates[it.key] = 0;
          }
        }
      });

      return cartFetch('update', { updates: updates });
    }
  }

  /* Container Event Delegation */
  container.addEventListener('click', function(e) {
    var target = e.target;

    /* Dismiss Nudge Tooltip */
    var nudgeClose = target.closest('#cp-nudge-close');
    if (nudgeClose) {
      e.preventDefault();
      var tooltip = container.querySelector('#cp-nudge-tooltip');
      if (tooltip) tooltip.style.display = 'none';
      nudgeWasDismissed = true;
      return;
    }

    /* Fold Trigger */
    var foldTrigger = target.closest('#cp-fold-trigger, .cp-subtle-folded-strip');
    if (foldTrigger) {
      e.preventDefault();
      e.stopPropagation();
      var panelEl = container.querySelector('#cp-unfolded-panel');
      if (panelEl) {
        var isCurrentlyHidden = (panelEl.style.display === 'none' || window.getComputedStyle(panelEl).display === 'none');
        if (isCurrentlyHidden) {
          panelEl.style.display = 'block';
          foldTrigger.classList.add('is-open');
          panelWasOpen = true;
          updateQtySelectOptions();
          var input = container.querySelector('#cp-text-input-field');
          if (input) {
            setTimeout(function() { input.focus(); }, 50);
          }
        } else {
          panelEl.style.display = 'none';
          foldTrigger.classList.remove('is-open');
          panelWasOpen = false;
        }
      }
      return;
    }

    /* SAVE Button for Personalisation */
    var applyBtn = target.closest('#cp-apply-btn, .cp-save-btn');
    if (applyBtn) {
      e.preventDefault();
      if (isSaving) return;

      var inputField = container.querySelector('#cp-text-input-field');
      var text = inputField ? inputField.value.trim().replace(/\s+/g, ' ') : '';
      if (!text) {
        if (inputField) {
          inputField.style.borderColor = '#d32f2f';
          inputField.focus();
        }
        return;
      }

      var targetSelect = container.querySelector('#cp-target-item-select');
      var selectedOpt = targetSelect && targetSelect.options[targetSelect.selectedIndex];
      var firstNonServiceDom = container.querySelector('.cart-item:not([data-service-item="true"])');
      
      var targetTitle = selectedOpt ? selectedOpt.value : (firstNonServiceDom ? firstNonServiceDom.dataset.productTitle : (container.dataset.firstItemTitle || FIRST_ITEM_TITLE));
      var targetKey = selectedOpt ? selectedOpt.dataset.itemKey : (firstNonServiceDom ? firstNonServiceDom.dataset.key : (container.dataset.firstItemKey || FIRST_ITEM_KEY));

      var qtySelect = container.querySelector('#cp-qty-select');
      var userEngraveQty = (qtySelect && qtySelect.value) ? Number(qtySelect.value) : 1;

      isSaving = true;
      applyBtn.disabled = true;
      applyBtn.classList.add('is-saving');

      function unlockSaveBtn() {
        isSaving = false;
        var btn = container.querySelector('#cp-apply-btn');
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-saving');
        }
      }

      resolveServiceVariantId().then(function(vId) {
        if (!vId) {
          showErrorToast('Personalisation service is currently unavailable.');
          unlockSaveBtn();
          return;
        }

        return fetch(root + 'cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cartData) {
            var nonServiceCartItems = cartData.items.filter(function(it) {
              var it_h = (it.handle || '').toLowerCase();
              var it_t = (it.product_type || '').toLowerCase();
              return !(it.id === Number(SERVICE_VARIANT_ID) || (it.properties && it.properties['_Artisan Role'] === 'service') || it_h.indexOf('monogrammed-leather-bags-fees') !== -1 || it_t.indexOf('gift card') !== -1 || it_t.indexOf('service') !== -1);
            });

            if (nonServiceCartItems.length > 0) {
              if (!targetKey || !cartData.items.find(function(it) { return it.key === targetKey; })) {
                targetKey = nonServiceCartItems[0].key;
              }
              if (!targetTitle) {
                targetTitle = nonServiceCartItems[0].product_title || nonServiceCartItems[0].title;
              }
            }

            var existingFeeItems = cartData.items.filter(function(it) {
              return ((SERVICE_VARIANT_ID && it.id === Number(SERVICE_VARIANT_ID)) ||
                      (it.product_title && it.product_title.indexOf('Monogram') !== -1) ||
                      (it.properties && it.properties['_Artisan Role'] === 'service')) &&
                     (it.properties && it.properties['Target Product'] === targetTitle);
            });

            var updates = {};
            existingFeeItems.forEach(function(feeIt) {
              updates[feeIt.key] = 0;
            });

            var bundleToken = 'artisan_b_' + Date.now();
            var properties = {
              'Engraving Text': text,
              'Personalisation': text,
              '_Engraving': 'Yes',
              'Target Product': targetTitle,
              '_Artisan Role': 'service',
              '_Artisan Bundle': bundleToken
            };

            var mainItem = cartData.items.find(function(it) { return it.key === targetKey; });
            var engraveQty = userEngraveQty;
            var totalQty = mainItem ? mainItem.quantity : 1;
            if (engraveQty > totalQty) engraveQty = totalQty;

            var stampMain = Promise.resolve();
            if (mainItem) {
              var mainProps = Object.assign({}, mainItem.properties || {}, {
                'Engraving Text': text,
                'Personalisation': text,
                '_Engraving': 'Yes',
                '_Artisan Bundle': bundleToken
              });

              if (engraveQty < totalQty) {
                var unengravedQty = totalQty - engraveQty;
                stampMain = fetch(root + 'cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: targetKey, quantity: engraveQty, properties: mainProps })
                }).then(function() {
                  return fetch(root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id: mainItem.variant_id || mainItem.id, quantity: unengravedQty }] })
                  });
                });
              } else {
                stampMain = fetch(root + 'cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: targetKey, quantity: engraveQty, properties: mainProps })
                });
              }
            }

            var removeOldFees = Object.keys(updates).length > 0
              ? fetch(root + 'cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ updates: updates })
                })
              : Promise.resolve();

            return removeOldFees
              .then(function() { return stampMain; })
              .then(function() {
                pendingInputText = '';
                return cartFetch('add', { items: [{ id: Number(vId), quantity: engraveQty, properties: properties }] });
              });
          });
      })
      .catch(function(err) {
        console.error('Save personalisation failed', err);
        showErrorToast('Failed to add personalisation. Please try again.');
      })
      .finally(function() {
        unlockSaveBtn();
      });

      return;
    }

    /* SYNCHRONIZED ITEM REMOVAL */
    var removeBtn = target.closest('.cart-item-remove');
    if (removeBtn) {
      e.preventDefault();
      var itemEl = removeBtn.closest('.cart-item');
      if (!itemEl) return;

      var targetKey = removeBtn.dataset.key || itemEl.dataset.key;

      fetch(root + 'cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cartData) {
          var targetItem = cartData.items.find(function(it) { return it.key === targetKey; });
          if (!targetItem) return;

          var updates = {};
          updates[targetKey] = 0;

          return cleanupBundledItems(cartData, targetItem, updates);
        });

      return;
    }

    /* Quantity selector buttons */
    if (target.matches('.qty-btn')) {
      e.preventDefault();
      var qtyItem = target.closest('.cart-item');
      if (!qtyItem || qtyItem.dataset.serviceItem) return;

      var input = qtyItem.querySelector('.qty-input');
      var currentQty = Number(input.value);
      var action = target.dataset.action;
      var newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);

      input.value = newQty;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        var key = qtyItem.dataset.key;

        if (newQty === 0) {
          fetch(root + 'cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cartData) {
              var targetItem = cartData.items.find(function(it) { return it.key === key; });
              if (!targetItem) return;

              var updates = {};
              updates[key] = 0;

              return cleanupBundledItems(cartData, targetItem, updates);
            });
        } else {
          var updates = {};
          updates[key] = newQty;
          cartFetch('update', { updates: updates });
        }
      }, DEBOUNCE_MS);
      return;
    }

    /* Upsell Add Button */
    var upsellBtn = target.closest('.upsell-add-btn');
    if (upsellBtn) {
      e.preventDefault();
      var variantId = upsellBtn.dataset.addVariant;
      cartFetch('add', { items: [{ id: Number(variantId), quantity: 1 }] });
    }
  });

  /* Input event for text counter & upper case */
  container.addEventListener('input', function(e) {
    if (e.target && e.target.id === 'cp-text-input-field') {
      var val = e.target.value.toUpperCase().replace(/[^A-Z0-9\s\.]/g, '').replace(/\s{2,}/g, ' ').slice(0, MAX_CHARS);
      e.target.value = val;
      var charCounter = container.querySelector('#cp-char-count');
      if (charCounter) charCounter.textContent = val.length;
      if (val.trim().length > 0) {
        e.target.style.borderColor = '#c9a96e';
      }
    }
  });

  /* Dynamic Quantity Selector Options Helper */
  function updateQtySelectOptions() {
    var targetSelect = container.querySelector('#cp-target-item-select');
    var qtyGroup = container.querySelector('#cp-qty-select-group');
    var qtySelect = container.querySelector('#cp-qty-select');
    if (!qtyGroup || !qtySelect) return;

    var selectedOpt = targetSelect && targetSelect.options[targetSelect.selectedIndex];
    var maxQty = selectedOpt ? Number(selectedOpt.dataset.itemQty || 1) : 1;

    if (maxQty > 1) {
      var html = '';
      for (var i = 1; i <= maxQty; i++) {
        var label = (i === maxQty) ? ('All ' + i + ' items') : (i + ' of ' + maxQty + ' items');
        html += '<option value="' + i + '">' + label + '</option>';
      }
      qtySelect.innerHTML = html;
      qtyGroup.style.display = 'block';
    } else {
      qtyGroup.style.display = 'none';
      qtySelect.innerHTML = '<option value="1">1 item</option>';
    }
  }

  container.addEventListener('change', function(e) {
    if (e.target && e.target.id === 'cp-target-item-select') {
      updateQtySelectOptions();
    }
  });

  /* Global Overlay & Close Button Event Bindings */
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('click', function(e) {
    if (e.target && e.target.closest('.classy-cart-close-btn')) {
      closeCart();
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen) closeCart();
  });

  /* Event Listeners for Theme Cart Events */
  document.addEventListener('product-form:submit:success', function() {
    refreshAndOpen();
  });

  document.addEventListener('product-form:cart:navigate', function(e) {
    if (e && e.preventDefault) e.preventDefault();
    refreshAndOpen();
  });

  window.addEventListener('cartcount:update', function() {
    if (isRefreshing) return; /* Guard: ignore if a refresh is already in-flight */
    if (isOpen) {
      refreshCart();
      return;
    }
    if (document.body.classList.contains('template-cart')) return;
    refreshAndOpen();
  });

  /* Global click listener to open drawer when cart header icons/links are clicked */
  document.addEventListener('click', function(e) {
    var cartLink = e.target.closest('a[href*="/cart"], .site-header-cart--button, .site-header-cart, [data-cart-drawer-open], [data-header-cart], .site-header__cart');
    if (cartLink) {
      if (window.location.pathname === '/cart') return;
      e.preventDefault();
      refreshAndOpen();
      return;
    }
    var viewCartBtn = e.target.closest('[data-atc-banner-cart-button], .atc-banner--cart-button');
    if (viewCartBtn) {
      e.preventDefault();
      refreshAndOpen();
    }
  });

  /* Expose methods on window */
  window.classyCartRefresh = refreshCart;
  window.classyCartRefreshAndOpen = refreshAndOpen;
  window.classyCartOpen  = openCart;
  window.classyCartClose = closeCart;
})();
